import React, {useState, useEffect } from 'react';

import InfoCard from '../../components/info-card/info-card.jsx';
import GallerySlide from '../../components/gallery-slide/gallery-slide.jsx';
import ContactForm from '../../components/contact-form/contact-form.jsx';
import ImageInfo from '../../components/image-info/image-info.jsx';
import InfoBox from '../../components/info-box/info-box.jsx';
import OverlayTextImage from '../../components/overlay-text-image/overlay-text-image.jsx';
import Seo from '../../Seo.js';
import './welcome-wrapper.css';

const WelcomeWrapper = ({data, isMobile}) => {

  const serviceCards = data?.serviceCards?.map((card, index) => {
    return (
      <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3 " key={index}>
        <InfoCard title={card?.title} text={card?.text}/>
      </div>
    )
  })

  const sideBySideContent = data?.sideBySideContent.map((card, index) => {
    return (
      // <div className="margin-top-5 sliding-container" key={index}>
      <div className="margin-top-5" key={index}>
        <ImageInfo 
          title={card.title} 
          text={card.text} 
          image={card.image} 
          isImageOnTheLeft={isMobile || card.isImageOnTheLeft}/>
      </div>
    )
  })

  const footerIcons = data?.footer?.socials.map((icon, index) => {
    return (
      <span key={index}>
        <a href={icon.link} target="_blank" rel="noreferrer" className="default-link">
          <i className={`social-icon fab fa-${icon.icon}`}></i>
        </a>
      </span>
    )
  })

  return (
    <div className="welcome-dashboard-wrapper relative-position dark-background">
        <Seo title="Home" description={data?.mission?.text} />
        <div className="home-body relative-position">

          <OverlayTextImage  
            image={data?.landingImage?.image} 
            imageSm={data?.landingImage?.imageSm} 
            title={data?.landingImage?.title} 
            slogan={data?.landingImage?.slogan}
            text={data?.landingImage?.text}
            alt={data?.landingImage?.alt}
            />

          <div className="row margin-bottom-5 margin-top-5">
            <InfoBox 
              // boxStyleClass="mission-statement-mobile"
              // styleClass="mobile-small-block-text" 
              title={null} text={data?.mission?.text}/>
          </div>
          
          
          {/* {isMobile?  
            <div className="row">
              <InfoBox title={data?.serviceTitle} isTitleOnly={true}/>
            </div> : ""
          } */}
          
          <div className="cards row justify-content-center">
            {serviceCards}
          </div>
          
          {sideBySideContent}

          {/* <GallerySlide 
            images={data?.imageSlideShow} 
            showThumbnails={true}/> */}

          <div className="margin-top-5">
            <ContactForm 
              detailsTitle={data?.contactDetails?.title} 
              phone={data?.contactDetails?.phone} 
              fax={data?.contactDetails?.fax} 
              email={data?.contactDetails?.email} 
              address={data?.contactDetails?.address} 
              addressLink={data?.contactDetails?.addressLink} 
              hideContactDetails={true} 
              showWithTwoColumns={true} />
          </div>
        </div>
        <div className='footer full-width margin-top-5'>
          <div className="container center">
            <div>
             {footerIcons}
            </div>
          </div>
          <div className="container center">
            <p>&copy; {data?.footer?.text}</p>
          </div>
        </div>
    </div>
  );

}

export default WelcomeWrapper;
